module.exports = {
  _name: "#if",
  _v: 1,
  mixins: [require("./directives"), require("./if")],
  _attrLookup: {
    "if": {
      "#": function(o) {
        var cb, comment, parent;
        comment = document.createComment("#if");
        parent = o.el.parentElement;
        cb = (function(_this) {
          return function() {
            return _this.$if({
              value: o.value,
              anchor: comment,
              els: [o.el]
            });
          };
        })(this);
        if (parent) {
          parent.appendChild(comment);
          return cb();
        } else if (this.$structure) {
          return this.$structure.beforeInsert.push(function(structure) {
            var index, value;
            index = structure.indexOf(o.el);
            if (index > -1) {
              value = this.$path.getValue(o.value);
              if (!value) {
                structure[index] = comment;
              } else {
                structure.splice(index, 0, comment);
              }
            } else {
              this.$structure.afterInsert.push(function() {
                return o.el.parentElement.insertBefore(comment, o.el.nextSibling);
              });
            }
            return this.$structure.afterInsert.push(cb);
          });
        } else {
          if(process.env.NODE_ENV!=='production' && true){console.warn('#if: no parent found for element: ' + o.el)};
          return null;
        }
      }
    }
  }
};

;



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/#if.js
// module id = 47
// module chunks = 1